<div class="modal-display dialog__form-container--limited-height" >
  <section>
    <h3 class="pb-5">Bank Account Overview</h3>

    <form [formGroup]="bankAccountForm">
      
      <div class="flex flex-row">
        <div class="form-control-div-half  flex-auto mobile-div">
          <h5>Investor</h5>
          <mat-form-field appearance="outline">
            <input matInput formControlName="investorName"/>
          </mat-form-field>
        </div>
        
        <div class="form-control-div-half  flex-auto mobile-div">
          <h5>Account Name</h5>
          <mat-form-field appearance="outline">
            <input matInput formControlName="bankAccountName"/>
          </mat-form-field>
        </div>

        <div class="form-control-div-half  flex-auto mobile-div">
          <h5>Account Number</h5>
          <mat-form-field appearance="outline">
            <input matInput formControlName="bankAccountNumber"/>
          </mat-form-field>
        </div>

        <div class="form-control-div-half  flex-auto mobile-div">
          <h5>Bank</h5>
          <mat-form-field appearance="outline">
            <input matInput formControlName="bankName"/>
          </mat-form-field>
        </div>

        <div class="form-control-div-third flex-auto mobile-div">
          <h5>Reference</h5>
          <mat-form-field appearance="outline">
            <input matInput formControlName="reference"/>
          </mat-form-field>
        </div>

        <div class="form-control-div-third flex-auto mobile-div">
          <h5>Currency</h5>
          <mat-form-field appearance="outline">
            <input matInput formControlName="currency"/>
          </mat-form-field>
        </div>

        <div class="form-control-div-third flex-auto mobile-div">
          <h5>Verified</h5>
          <mat-checkbox formControlName="isVerified" disableRipple></mat-checkbox>
        </div>
      </div>
    </form>

    <div class="modal-buttons dialog__form-footer--medium">
      <button *ngIf="userCanApproveOrRejectBankAccount" class="a-rounded-button a-rounded-button--primary a-rounded-button--primary-outline" (click)="rejectBankAccount(bankAccount)">Reject</button>
      <button *ngIf="userCanApproveOrRejectBankAccount" class="a-rounded-button a-rounded-button--primary a-rounded-button--primary-outline ml-3" (click)="approveBankAccount(bankAccount)">Approve</button>
      <button class="a-rounded-button--primary" (click)="closeDialog()">OK</button>
    </div>
  </section>
</div>